export class AzureUser {
  displayName: string;
  givenName: string;
  mail: string;
  department: string;
  surname: string;
  jobTitle: string;
  id: string;
}
